import { render, staticRenderFns } from "./Selector.vue?vue&type=template&id=78908c4e&scoped=true&"
import script from "./Selector.vue?vue&type=script&lang=ts&"
export * from "./Selector.vue?vue&type=script&lang=ts&"
import style0 from "./Selector.vue?vue&type=style&index=0&id=78908c4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78908c4e",
  null
  
)

export default component.exports